module.exports = __webpack_public_path__ + "img/DE02131.efe04e15.png";